<div
    class="page-anchor page-anchor_blue"
    [ngClass]="{ 'page-anchor_hidden': isHidden }"
>
    <span observeVisibility [threshold]="1" (onVisible)="intersected.emit()">
        <ng-content></ng-content>
    </span>
</div>
